module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-81.48b75cb9.jpg";